export function search() {
  const searchType01 = document.querySelector('.js-searchType01');
  const check_groups = document.querySelectorAll('.js-checkGroup');

  const allCheck = () => {
    let queries = window.location.search;
    if(!queries) {
      const allValInputs = searchType01.querySelectorAll('input[data-value="all"]');
      allValInputs.forEach(element => {
        element.checked = true;
      });
    }
  }

  //チェックボックスの値を引き継ぐ
  const funcCheckParams = () => {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    let keys = [];
    params.forEach(function(value,key){
      keys.push(key);
      keys = Array.from(new Set(keys));
    });

    keys.forEach(key => {
      const inputs = searchType01.querySelectorAll(`input[name="${key}"]`);
      const values = params.getAll(key);
      const checkedInputs = Array.from(inputs).filter(x => values.includes(x.value));
      checkedInputs.forEach(element => {
        element.checked = true;
      });
    })
  }

  for (let index = 0; index < check_groups.length; index++) {
    const check_group = check_groups[index];
    const check_inputs = check_group.querySelectorAll('input');

    check_inputs.forEach(check_input => {
      check_input.addEventListener('change', function () { //チェックボックスの値が変わる
        funcCheckAll(this, check_inputs);
      })
    });
  }

  //全選択関連
  const funcCheckAll = (el, array) => {
    let data_value = el.dataset.value
    if(data_value === 'all') { //「すべて」をチェック
      array.forEach(element => {
        if(element !== el) {
          //「すべて」以外のチェックを外す
          element.checked = false;
        }
      });
    } else {
      array.forEach(element => { //「すべて」以外をチェック
        if(element.dataset.value === 'all') {
          //「すべて」のチェックを外す
          element.checked = false;
        }
      });
    }
  }

  window.addEventListener('load', () => {
    if(searchType01) {
      allCheck();
      funcCheckParams();
    }
  })
}